import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScvImportModal from '../ScvImport/ScvImportModal';
import GoogleScholarModal from '../GoogleScholar/GoogleScholarModal';
import '../../../css/ContactInformation.css';

const ContactInformationListing = ({
    profile,
    workHistories = [],
    educationHistories = [],
    researchFields = [],
    teachingMajors = [],
    academicTitles = [],
    foreignLanguages = [],
    departments = [],
    onEditClick,
    isLoading
}) => {
    const navigate = useNavigate();

    const [isScvModalOpen, setIsScvModalOpen] = useState(false);
    const [isScholarModalOpen, setIsScholarModalOpen] = useState(false);

    if (isLoading || !profile) {
        return <div style={{ textAlign: 'center', padding: '50px' }}><i className="fa-solid fa-circle-notch fa-spin"></i> Đang tải thông tin</div>;
    }

    const fullName = `${profile.LastName || ''} ${profile.FirstName || ''}`.trim() || 'Chưa cập nhật tên';

    let displayDateOfBirth = '---';
    if (profile.DateOfBirth && typeof profile.DateOfBirth === 'string') {
        const dateOnly = profile.DateOfBirth.substring(0, 10);
        if (dateOnly.includes('-')) {
            displayDateOfBirth = dateOnly.split('-').reverse().join('-');
        } else {
            displayDateOfBirth = profile.DateOfBirth;
        }
    }

    const getYear = (dateStr) => {
        if (!dateStr) return "";
        return dateStr.substring(0, 4);
    };

    const sortHistoryObjects = (histories) => {
        if (!histories || histories.length === 0) return [];
        return [...histories].sort((a, b) => {
            const getYearValue = (dateStr) => {
                if (!dateStr || dateStr.toLowerCase().includes('nay') || dateStr.toLowerCase().includes('hiện')) return 9999;
                return parseInt(dateStr.substring(0, 4)) || 0;
            };

            const endA = getYearValue(a.EndDate);
            const endB = getYearValue(b.EndDate);

            if (endA !== endB) {
                return endB - endA;
            }
            const startA = getYearValue(a.StartDate);
            const startB = getYearValue(b.StartDate);
            return startB - startA;
        });
    };

    const sortedWorkHistories = sortHistoryObjects(workHistories);
    const sortedEducationHistories = sortHistoryObjects(educationHistories);

    let scvSearchDept = '';
    if (departments && departments.length > 0 && profile.DepartmentId) {
        const matchedDept = departments.find(d => d.Id === profile.DepartmentId);
        if (matchedDept) {
            scvSearchDept = matchedDept.Name;
        }
    }

    const currentAcademicTitle = academicTitles && academicTitles.length > 0
        ? (academicTitles.find(t => t.IsCurrent) || academicTitles[0])
        : null;

    return (
        <div className="profile-layout-container">
            <div className="profile-sidebar" style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ width: '80px', height: '80px', backgroundColor: '#2c3e50', borderRadius: '8px', overflow: 'hidden', flexShrink: 0 }}>
                        {profile.AvatarUrl ? (
                            <img src={profile.AvatarUrl} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                            <i className="fa-solid fa-user-tie" style={{ fontSize: '40px', color: '#fff', margin: '20px' }}></i>
                        )}
                    </div>
                    <div>
                        <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#2c3e50' }}>{fullName}</h3>
                        <button
                            onClick={onEditClick}
                            style={{ backgroundColor: '#3498db', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', transition: '0.3s' }}
                        >
                            Chỉnh sửa thông tin
                        </button>
                    </div>
                </div>

                <div style={{ fontSize: '14px', color: '#555', marginBottom: '20px', lineHeight: '1.8' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                        <strong>Email:</strong> <span style={{ wordBreak: 'break-all', textAlign: 'right' }}>{profile.Email || '---'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                        <strong>Số ĐT:</strong> <span style={{ textAlign: 'right' }}>{profile.PhoneNumber || '---'}</span>
                    </div>
                </div>

                <hr style={{ border: '0', borderTop: '1px solid #eee', marginBottom: '20px' }} />

                <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '14px', lineHeight: '2.5' }}>
                    <li
                        onClick={() => navigate('/ly-lich-khoa-hoc')}
                        onMouseOver={(e) => e.target.style.color = '#3498db'}
                        onMouseOut={(e) => e.target.style.color = '#333'}
                        style={{ cursor: 'pointer', color: '#333', transition: '0.2s' }}
                    >
                        <i className="fa-solid fa-id-card" style={{ width: '25px', pointerEvents: 'none' }}></i>
                        Xem CV cá nhân
                    </li>
                    {/* <li
                        onClick={() => setIsScvModalOpen(true)}
                        onMouseOver={(e) => e.target.style.color = '#3498db'}
                        onMouseOut={(e) => e.target.style.color = '#333'}
                        style={{ cursor: 'pointer', color: '#333', transition: '0.2s' }}
                    >
                        <i className="fa-solid fa-file-import" style={{ width: '25px', pointerEvents: 'none' }}></i>
                        Nhập dữ liệu từ SCV UDN
                    </li>
                    <li
                        onClick={() => setIsScholarModalOpen(true)}
                        onMouseOver={(e) => e.target.style.color = '#3498db'}
                        onMouseOut={(e) => e.target.style.color = '#333'}
                        style={{ cursor: 'pointer', color: '#333', transition: '0.2s' }}
                    >
                        <i className="fa-brands fa-google" style={{ width: '25px', pointerEvents: 'none' }}></i>
                        Nhập dữ liệu từ Google Scholar
                    </li> */}
                    <li
                        onClick={() => navigate('/lich-su-hoat-dong')}
                        onMouseOver={(e) => e.target.style.color = '#3498db'}
                        onMouseOut={(e) => e.target.style.color = '#333'}
                        style={{ cursor: 'pointer', color: '#333', transition: '0.2s' }}
                    >
                        <i className="fa-solid fa-clock-rotate-left" style={{ width: '25px', pointerEvents: 'none' }}></i>
                        Lịch sử hoạt động
                    </li>
                </ul>
            </div>

            <div className="profile-main" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <h4 style={{ borderLeft: '4px solid #3498db', paddingLeft: '10px', color: '#2c3e50', marginBottom: '20px' }}>Thông tin cá nhân</h4>

                    <div className="profile-info-grid" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                        <div>Họ và tên:</div>
                        <div style={{ color: '#333' }}>{fullName}</div>

                        <div>Giới tính:</div>
                        <div style={{ color: '#333' }}>{profile.Gender || '---'}</div>

                        <div>Ngày sinh:</div>
                        <div style={{ color: '#333' }}>{displayDateOfBirth}</div>

                        <div>Nơi sinh:</div>
                        <div style={{ color: '#333' }}>{profile.PlaceOfBirth || '---'}</div>

                        <div>Dân tộc:</div>
                        <div style={{ color: '#333' }}>{profile.Ethnicity || '---'}</div>

                        <div>Quê quán:</div>
                        <div style={{ color: '#333' }}>{profile.Hometown || '---'}</div>

                        <div>Chức vụ:</div>
                        <div style={{ color: '#333' }}>{profile.AdminPosition || '---'}</div>

                        <div>Đơn vị công tác:</div>
                        <div style={{ color: '#333' }}>{profile.DepartmentName || '---'}</div>

                        <div>Địa chỉ liên hệ:</div>
                        <div style={{ color: '#333' }}>{profile.ContactAddress || '---'}</div>

                        <div>Học vị:</div>
                        <div style={{ color: '#333' }}>
                            {currentAcademicTitle?.DegreeName || profile.Degree || 'Chưa cập nhật'}
                        </div>

                        <div>Chức danh:</div>
                        <div style={{ color: '#333' }}>
                            {currentAcademicTitle?.TitleName
                                ? `${currentAcademicTitle.TitleName}${currentAcademicTitle.AcademicRank ? ` (${currentAcademicTitle.AcademicRank})` : ''}`
                                : (profile.AcademicTitle || 'Chưa cập nhật')}
                        </div>

                        <div>Dạy chuyên ngành:</div>
                        <div style={{ color: '#333' }}>
                            {teachingMajors.length > 0 ? teachingMajors.map(item => item.TeachingMajorName).join('; ') : (profile.TeachingMajor || 'Chưa cập nhật')}
                        </div>

                        <div>Lĩnh vực nghiên cứu:</div>
                        <div style={{ color: '#333' }}>
                            {researchFields.length > 0 ? researchFields.map(item => item.ResearchFieldName).join('; ') : (profile.ResearchField || 'Chưa cập nhật')}
                        </div>

                        <div>Ngoại ngữ:</div>
                        <div style={{ color: '#333' }}>
                            {foreignLanguages.length > 0
                                ? [...new Set(foreignLanguages.map(item => item.LanguageName))].join(', ')
                                : (profile.ForeignLanguage || 'Chưa cập nhật')}
                        </div>

                        <div>Google Scholar:</div>
                        <div style={{ color: '#3498db', wordBreak: 'break-word' }}>
                            {profile.GoogleScholarLink ? (
                                <a href={profile.GoogleScholarLink} target="_blank" rel="noreferrer" style={{ color: '#3498db', textDecoration: 'none' }}>
                                    {profile.GoogleScholarLink}
                                </a>
                            ) : '---'}
                        </div>

                        <div>ORCID:</div>
                        <div style={{ color: '#3498db', wordBreak: 'break-word' }}>
                            {profile.OrcidLink ? (
                                <a href={profile.OrcidLink} target="_blank" rel="noreferrer" style={{ color: '#3498db', textDecoration: 'none' }}>
                                    {profile.OrcidLink}
                                </a>
                            ) : '---'}
                        </div>
                    </div>
                </div>

                <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <h4 style={{ borderLeft: '4px solid #3498db', paddingLeft: '10px', color: '#2c3e50', marginBottom: '15px' }}>Quá trình công tác</h4>
                    <div style={{ fontSize: '14px', color: '#333', paddingLeft: '15px' }}>
                        {sortedWorkHistories.length === 0 ? (
                            <span style={{ color: '#888' }}>Chưa có dữ liệu quá trình công tác</span>
                        ) : (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {sortedWorkHistories.map((item, index) => (
                                    <li key={index} className="history-list-item" style={{ marginBottom: '12px' }}>
                                        <div className="history-time" style={{ fontWeight: 'bold', color: '#555' }}>
                                            {getYear(item.StartDate)} - {item.EndDate ? getYear(item.EndDate) : "Hiện tại"}:
                                        </div>
                                        <div className="history-content">
                                            {item.Position && <span>{item.Position} tại </span>}
                                            <span>{item.Workplace}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <h4 style={{ borderLeft: '4px solid #3498db', paddingLeft: '10px', color: '#2c3e50', marginBottom: '15px' }}>Quá trình đào tạo</h4>
                    <div style={{ fontSize: '14px', color: '#333', paddingLeft: '15px' }}>
                        {sortedEducationHistories.length === 0 ? (
                            <span style={{ color: '#888' }}>Chưa có dữ liệu quá trình đào tạo</span>
                        ) : (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {sortedEducationHistories.map((item, index) => (
                                    <li key={index} className="history-list-item" style={{ marginBottom: '12px' }}>
                                        <div className="history-time" style={{ fontWeight: 'bold', color: '#555' }}>
                                            {getYear(item.StartDate)} - {getYear(item.EndDate)}:
                                        </div>
                                        <div className="history-content">
                                            <span style={{ fontWeight: '500' }}>{item.EducationLevel}</span>
                                            <span> Ngành {item.Major}</span>
                                            {item.Specialization && <span>, Chuyên ngành {item.Specialization}</span>}
                                            <span> tại {item.School}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            <ScvImportModal
                isOpen={isScvModalOpen}
                onClose={() => setIsScvModalOpen(false)}
                onImportSuccess={() => { window.location.reload(); }}
                defaultName={fullName}
                defaultDept={scvSearchDept}
            />
            <GoogleScholarModal
                isOpen={isScholarModalOpen}
                onClose={() => setIsScholarModalOpen(false)}
                defaultLink={profile.GoogleScholarLink}
            />
        </div>
    );
};

export default ContactInformationListing;